import { SortDirection } from '@empathy/search-types';
import { COMPONENTS, DeepPartial, SortConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SORT_CONFIG: DeepPartial<SortConfig> = {
  components: {
    sortIcon: COMPONENTS.PURE.ChevronUpIcon,
    sort: COMPONENTS.PURE.SortDropdown
  },
  iconSlot: 'dropdown-icon',
  sorts:
    [
      {
        title: 'default',
        value: ''
      },
      {
        title: 'priceAsc',
        value: 'price asc',
        direction: SortDirection.ASC
      },
      {
        title: 'priceDesc',
        value: 'price desc',
        direction: SortDirection.DESC
      },
      {
        title: 'alphabeat',
        value: 'name asc',
        direction: SortDirection.ASC
      }
    ]

};
